// https://github.com/asyncapi/parser-api/releases/tag/v3.0.0
export const ParserAPIVersion = 3;
